module.exports = __webpack_public_path__ + "static/media/a2hs_dark.65e218d8.png";